var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownloadTool(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u56FE\\u5C42_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 16 16",
    style: {
      enableBackground: "new 0 0 16 16"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:#B46E6E;fill-opacity:0;}\n\t.st1{fill:#FFFFFF;}\n\t.st2{fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;}\n")), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ic-\u5F00\u653E\u5E73\u53F0\u5907\u4EFD") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u5BFC\\u822A\\u4F18\\u5316"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u753B\\u677F",
    transform: "translate(-416, -40.0178)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-35",
    transform: "translate(414, 39)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62",
    x: 2,
    y: 1,
    className: "st0",
    width: 16,
    height: 16
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u5F62\\u72B6\\u7ED3\\u5408",
    className: "st1",
    d: "M16,4v11H4V4h3v1H5v9h10V5h-2V4H16z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u5F62\\u72B6\\u7ED3\\u5408_1_",
    className: "st2",
    d: "M10.5,2l0,4.5h1.6L10,9.7L7.9,6.5h1.6l0-4.5H10.5z M7,11h6v1H7V11z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadTool);
export default __webpack_public_path__ + "static/media/download-tool.c81882523fd5ca3f2af361e4a64bf994.svg";
export { ForwardRef as ReactComponent };